import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { Service, inject } from '@piwikpro/platform';
import type { Store } from 'redux';

@Service()
export class MarketingService {
  private session: SessionState;

  constructor(
    @inject('store') private readonly store: Store,
  ) {
    this.session = {
      ...this.store.getState().session,
      language: this.store.getState().session.language.split('-')[0],
    };
  }

  private getPiwikProductPricingPageURL() {
    switch (this.session.language) {
      case 'de':
        return 'https://piwikpro.de/preise/';
      case 'fr':
        return 'https://piwikpro.fr/pricing/';
      case 'nl':
        return 'https://piwikpro.nl/piwik-pro-pakketten/';
      case 'sv':
        // there is no dedicated pricing page for now
        return 'https://piwikpro.se/';
      case 'en':
      case 'fi':
      default:
        return 'https://piwik.pro/pricing/';
    }
  }

  public getPiwikProductPricingTablePageURL() {
    switch (this.session.language) {
      case 'de':
        return 'https://piwikpro.de/preise/#uberblick';
      case 'fr':
        return 'https://piwikpro.fr/pricing/#comparaison-des-plans';
      case 'nl':
        return 'https://piwikpro.nl/piwik-pro-pakketten/#vergelijking-van-abonnementen';
      case 'sv':
      case 'en':
      case 'fi':
      case 'it':
      case 'da':
      default:
        return 'https://piwik.pro/pricing/#table';
    }
  }

  public openProductPricingPage(): void {
    window.open(
      this.getPiwikProductPricingPageURL(),
      '_blank',
    );
  }

  public openProductPricingTablePage(): void {
    window.open(
      this.getPiwikProductPricingTablePageURL(),
      '_blank',
    );
  }
}
